import * as React from 'react';
import { Link } from 'react-router';

import PropTypes from 'prop-types';

import Button from 'bundles/internal-ui/components/buttons/Button';

const tabs = [
  {
    link: '/internal/enterprise/trigger/program',
    buttonText: 'Program Settings',
  },
  {
    link: '/internal/enterprise/trigger/organization',
    buttonText: 'Organization Settings',
  },
];

const EnterpriseToolTabs = (props: $TSFixMe, { router }: $TSFixMe) => (
  <ul className="enterprise-switcher nav nav-tabs" role="tablist">
    {tabs.map((tab, idx) => (
      // eslint-disable-next-line react/no-array-index-key
      <li key={idx} className={router.isActive(tab.link) && 'active'}>
        <Link
          to={{
            pathname: tab.link,
            query: router.location.query,
          }}
        >
          <Button text={tab.buttonText} btnStyle="link" />
        </Link>
      </li>
    ))}
  </ul>
);

EnterpriseToolTabs.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default EnterpriseToolTabs;
